import classNames from 'classnames';

import Icon from '../../icons/icon';

import styles from './visit_share_link_button.module.css';

/**
 * In dev environments (PR test domains and localhost), we adjust the share URL
 * to use the current hostname so that the links open in the same environment.
 */
export function getShareUrlForDev(shareUrl: string): string {
  const hostname = window.location.hostname;
  const isPrDomain = /^web-pr-\d+\.pr\.test\.iconik\.cloud$/.test(hostname);
  const isLocalhost = hostname === 'localhost';

  if (shareUrl && (isPrDomain || isLocalhost)) {
    const url = new URL(shareUrl);
    url.protocol = window.location.protocol;
    url.hostname = window.location.hostname;
    if (window.location.port) {
      url.port = window.location.port;
    }
    return url.toString();
  }

  return shareUrl;
}

type VisitShareLinkButtonProps = {
  url: string;
  targetBlank?: boolean;
};
function VisitShareLinkButton({ url, targetBlank }: VisitShareLinkButtonProps) {
  const adjustedUrl = getShareUrlForDev(url);

  const classes = classNames(styles.share_visit_share_link_button, {
    [styles.share_visit_share_link_button_disabled]: !adjustedUrl,
  });

  return (
    <a
      href={adjustedUrl}
      className={classes}
      target={targetBlank ? '_blank' : '_self'}
    >
      {targetBlank ? <Icon icon="GoToPage" /> : null}
      Visit Share
    </a>
  );
}

export default VisitShareLinkButton;
